import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AuthService, Rights} from '../services/auth.service';
import { AuthenticatedStatus, AuthTokenService } from '../services/auth-token.service';
import { defaultErrorHandler } from '../services/backend-caller.service';

export type AuthorizedCheckCallback = (rights: Rights) => boolean;

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {

  public constructor(
    private authService: AuthService,
    private authTokenService: AuthTokenService,
    private router: Router,
  ) {
  }

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const rights$ = this.authService.getRights().pipe(defaultErrorHandler('Не удалось получить права пользователя'));

    const authorized = next.routeConfig.data.authorizeCheck as AuthorizedCheckCallback;

    return rights$.pipe(
      map((rights) => {
        if (this.authTokenService.getAuthenticatedStatus() === AuthenticatedStatus.notAuthenticated) {
          return false;
        }
        const isAuthorized = authorized(rights);

        if (!isAuthorized) {
          this.router.navigate(['forbidden']);
        }

        return isAuthorized;
      })
    );
  }
}
